import { Lightning, Lightning as lng, Utils } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';

const _Constants = {
  h: 100,
  padding: 8,
  textFontSize: 30,
  textIndent: 20,
  iconSize: 48,
};

export class CheckBox extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      rect: true,
      color: Theme.Colors.Transparent,
      h: _Constants.h,
      w: w => w,
      Background: {
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 10,
        },
        rect: true,
        x: 0,
        y: 0,
        w: w => w,
        h: _Constants.h,
        color: Theme.Colors.Option.Background.Item,
      },
      Label: {
        x: _Constants.textIndent,
        w: w => w,
        h: _Constants.h,

        text: {
          textAlign: 'left',
          textBaseline: 'ideographic',
          fontSize: _Constants.textFontSize,
          verticalAlign: 'middle',
          lineHeight: _Constants.h,
          color: Theme.Colors.Option.Text.Normal,
        },
      },
      Checkbox: {
        x: w => w - _Constants.iconSize * 1.5,
        y: _Constants.h / 2,
        mountY: 0.5,
        w: _Constants.iconSize,
        h: _Constants.iconSize,
        src: Utils.asset('images/dialog/ic_checked_checkbox.png'),
      },
    };
  }

  set value(val) {
    this.signal('valueChanged', val);
    this._value = val;
    if (val) {
      this.tag('Checkbox').src = Utils.asset('images/dialog/ic_checked_checkbox.png');
    } else {
      this.tag('Checkbox').src = Utils.asset('images/dialog/ic_empty_checkbox.png');
    }
  }

  set label(val) {
    const labelTag = this.tag('Label');
    const labelTexture = labelTag.text;
    labelTexture.text = val;
  }

  _handleEnter() {
    this.value = !this._value;
  }

  _focus() {
    this.tag('Background').setSmooth('color', Theme.Colors.Option.Background.Focus);
  }

  _unfocus() {
    this.tag('Background').setSmooth('color', Theme.Colors.Option.Background.Item);
  }
}
